import { formatNumberToRu } from 'utils';

import type React from 'react';

import Styles from './WorkOrderVersionSummaryItem.module.css';

interface IWorkOrderSummaryItemProps {
    // TODO: !!!
    item: any;
}

export const WorkOrderVersionSummaryItem: React.FC<IWorkOrderSummaryItemProps> = (props) => {
    const { item } = props;

    return (
        <div className={Styles.workOrderSummaryItem}>
            <div className={Styles.workOrderSummaryItemHeader}>{item.title}</div>
            <div className={Styles.workOrderSummaryItemData}>
                {item.costResults?.map(
                    (
                        itemData: {
                            name:
                                | boolean
                                | React.ReactChild
                                | React.ReactFragment
                                | React.ReactPortal
                                | null
                                | undefined;
                            value: any;
                        },
                        index: React.Key | null | undefined,
                    ) => (
                        <div key={index} className={Styles.workOrderSummaryItemDataRow}>
                            <div className={Styles.workOrderSummaryItemDataColumnName}>{itemData.name}</div>
                            <div className={Styles.workOrderSummaryItemDataColumnValue}>
                                {formatNumberToRu(Number(itemData.value), 2)}
                            </div>
                        </div>
                    ),
                )}
            </div>
        </div>
    );
};

WorkOrderVersionSummaryItem.displayName = 'WorkOrderVersionSummaryItem';
